export const AttributePicker = (function($) {
    const bindEvents = () => {
        $(document)
            .on('click', '[data-attribute-picker-trigger]', togglePicker)
            .on('click', '[data-attribute-picker-list]', keepOpen)
            .on('change', '[data-filter-input]', updateCount)
    };

    const togglePicker = (e) => {
        e.stopPropagation();

        const $picker = $(e.target).closest('[data-attribute-picker]');

        $('[data-attribute-picker].active')
            .not($picker)
            .removeClass('active'); // remove active class for other pickers

        $picker.toggleClass('active'); // toggle class for this picker
    };
    const keepOpen = (e) => e.stopPropagation();
    const updateCount = (e) => {
        const $picker = $(e.target).closest('[data-attribute-picker]');
        const count = $picker.find('[data-filter-input]:checked').length;
        const $count = $picker.find('[data-attribute-picker-count]');

        if (count > 0) {
            $count.text(`${count} selected`)
            $count.show();
        } else {
            $count.hide();
        }
    };

    return {
        init() { bindEvents(); }
    };

})(jQuery); // pass jQuery once